<template>
    <LoadingComponent :props="loading" />

    <div id="socialMedia" class="db-card db-tab-div active" :class="{ 'on-update': onUpdateActive }">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("menu.social_media") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="db-card-body">
            <form @submit.prevent="save" class="w-full d-block">
                <div class="form-row">
                    <div class="form-col-12 sm:form-col-6">
                        <label for="social_media_facebook" class="db-field-title">{{ $t("label.facebook") }}</label>
                        <input v-model="form.social_media_facebook" v-bind:class="errors.social_media_facebook ? 'invalid' : ''
                            " type="text" id="social_media_facebook" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.social_media_facebook">{{
                            errors.social_media_facebook[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="social_media_youtube" class="db-field-title">{{ $t("label.youtube") }}</label>
                        <input v-model="form.social_media_youtube" v-bind:class="errors.social_media_youtube ? 'invalid' : ''
                            " type="text" id="social_media_youtube" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.social_media_youtube">{{
                            errors.social_media_youtube[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="social_media_instagram" class="db-field-title">{{ $t("label.instagram") }}</label>
                        <input v-model="form.social_media_instagram" v-bind:class="errors.social_media_instagram ? 'invalid' : ''
                            " type="text" id="social_media_instagram" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.social_media_instagram">{{
                            errors.social_media_instagram[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 sm:form-col-6">
                        <label for="social_media_twitter" class="db-field-title">{{ $t("label.twitter") }}</label>
                        <input v-model="form.social_media_twitter" v-bind:class="errors.social_media_twitter ? 'invalid' : ''
                            " type="text" id="social_media_twitter" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.social_media_twitter">{{
                            errors.social_media_twitter[0]
                        }}</small>
                    </div>
                    <div class="form-col-12 border-t pt-5 mt-3">
                        <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                            <template v-if="isSaving">
                                <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                    <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                </svg>
                                <span>{{ $t('button.updating') }}</span>
                            </template>
                            <template v-else>
                                <i class="lab lab-fill-save"></i>
                                <span>{{ $t("button.save") }}</span>
                            </template>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";

export default {
    name: "SocialMediaComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            form: {
                social_media_facebook: "",
                social_media_youtube: "",
                social_media_instagram: "",
                social_media_twitter: "",
            },
            isSaving: false,
            onUpdateActive: false,
            errors: {},
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("socialMedia/lists")
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        Object.assign(this.form, res.data.data);
                    }
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        save: function () {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                this.$store.dispatch("socialMedia/save", this.form).then((res) => {
                    alertService.successFlip(
                        res.config.method === "put" ?? 0,
                        this.$t("menu.social_media")
                    );
                    this.$store.dispatch("socialMedia/lists").then((response) => {
                        this.form = {
                            social_media_facebook: response.data.data.social_media_facebook,
                            social_media_youtube: response.data.data.social_media_youtube,
                            social_media_instagram: response.data.data.social_media_instagram,
                            social_media_twitter: response.data.data.social_media_twitter,
                        };
                    }).catch(() => {
                        // Ignore refresh errors after successful save.
                    });
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response.data.errors;
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        }
    }
};
</script>